<template>
  <div :class="'popup ' + (type + '-popup ')" @click="close()"> 
    <loading small="true" v-if="type === 'loading'"/>
    <div class="text">{{ message ? message : '' }}</div>
    <div class="close">close</div>
  </div>
</template>

<script>
  export default {
    name: 'Notification',
    components: {
    },
    props: {
      message: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      top: {
        type: Boolean
      }
    },
    data: function () {
      var t = this;
      return {
       
      }
    },
    mounted: function () {
      var t = this;
    },
    methods: {
      close: function() {
        this.$emit('closed');
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "src/css/vars.scss";
  .popup {
    display: block;
    position: fixed;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.96);
    border-radius: 10px;
    padding: 10px 20px 8px;
    right: 20px;
    bottom: 20px;
    cursor: pointer;

    -webkit-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);

    &:hover {
      background-color: $background-color;
    }

    .close {
      font-size: 8pt;
      margin-top: 10px;
      color: $dark-font-color;
      text-align: right;
      display: none;

      &:hover {
        color: $primary-color-hover;
      }
    }
  }

  .text {
    display: inline-block;
  }

  .loading-popup {
    .text {
      vertical-align: top;
    }

    background-color: rgba(255, 255, 255, 0.85);
  }
  
  .error-popup {
    color: #ff3860;

    .close {
      display: block;
    }
  }

  /* Small only */
  @media screen and (max-width: 39.9375em) {
    .popup {
      max-width: 94%;
    }
  }

  /* Medium and up */
  @media screen and (min-width: 40em) {
    .popup {
      max-width: 50%;
    }
  }

  /* Large and up */
  @media screen and (min-width: 64em) {
    .popup {
      max-width: 30%;
    }
  }
</style>